import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Patient } from '../models/patient';
import { PatientUpdate } from '../models/patientUpdate';
import { CommentaireSurPatient } from '../models/CommentaireSurPatient';
import {Support} from '../models/Support';
import {SupportOffline} from '../models/SupportOffline';

@Injectable()
export class PatientService {
  private apiUrl: string;

  constructor(private http: HttpClient, private _appConfig: AppConfigService) {
      this.apiUrl = _appConfig.config.servicesBaseUrl;
  }

  getPatient(patientId: number) {
    return this.http.get<any>(this.apiUrl + `/pat/` + patientId)
        .pipe(map(pat => {
            return pat;
        }));
  }

  getCommentaireSurPatient(patientId: number) {
    return this.http.get<CommentaireSurPatient>(this.apiUrl + `/pat/` + patientId + `/com`)
        .pipe(map(pat => {
            return pat;
        }));
  }

  updateCommentaireSurPatient(patientId: number, commentaireSurpatient: CommentaireSurPatient) {
    return this.http.put<CommentaireSurPatient>(this.apiUrl + `/pat/` + patientId + `/com`, commentaireSurpatient)
      .pipe(map(pat => {
        return pat;
      }));
  }

  updateDateFinMutuelle(patKey: number, dateFinMutuelle: string) {
    const val = {
      patientKey: patKey,
      mutuelleDateFinDroit: dateFinMutuelle
    };
    return this.http.put<Patient>(this.apiUrl + `/pat/` + patKey.toString() + '/mut', val)
        .pipe(map(pat => {
            return pat;
        }));
  }

  getLivraisonsForPatient(patientId: number) {
    return this.http.get(this.apiUrl + `/pat/` + patientId + '/orders')
        .pipe(map(pat => {
            return pat;
        }));

  }

  supportRequest(patientId: number, question: Support) {
    return this.http.put(this.apiUrl + `/pat/` + patientId + '/support', question)
      .pipe(map(pat => {
        return pat;
      }));
  }

  getSupportSubjects() {
    return this.http.get(this.apiUrl + `/template-mail/support/sujets/connected`)
        .pipe(map(subjects => {
            return subjects;
        }));
  }

  supportOfflineRequest(question: SupportOffline) {
    return this.http.post(this.apiUrl + `/public/support/question`, question)
      .pipe(map(pat => {
        return pat;
      }));
  }

  getSupportOfflineSubjects() {
    return this.http.get(this.apiUrl + `/public/support/sujets`)
      .pipe(map(subjects => {
            return subjects;
        }));
  }

  createAssociatedPatient(data) {
      return this.http.post(this.apiUrl + `/affiliated-patient/`, data)
          .pipe(map(pat => {
              return pat;
          }));
  }

  updateMainPatientIdentity(data, patientKey: number) {
      return this.http.put<any>(this.apiUrl + `/main-patient/` + patientKey + `/identity`, data)
          .pipe(map(pat => {
              return pat;
          }));
  }

    updateMainPatientAddress(data, patientKey: number) {
        return this.http.put<any>(this.apiUrl + `/main-patient/` + patientKey + `/address`, data)
            .pipe(map(pat => {
                return pat;
            }));
    }

    updateMainPatientSS(data, patientKey: number) {
        return this.http.put<any>(this.apiUrl + `/main-patient/` + patientKey + `/social-security`, data)
            .pipe(map(pat => {
                return pat;
            }));
    }

    updateMainPatientMutual(data, patientKey: number) {
        return this.http.put<any>(this.apiUrl + `/main-patient/` + patientKey + `/mutual`, data)
            .pipe(map(pat => {
                return pat;
            }));
    }

    updateAffiliatedPatientIdentity(data, patientKey: number) {
        return this.http.put<any>(this.apiUrl + `/affiliated-patient/` + patientKey + `/identity`, data)
            .pipe(map(pat => {
                return pat;
            }));
    }

    updateAffiliatedPatientSS(data, patientKey: number) {
        return this.http.put<any>(this.apiUrl + `/affiliated-patient/` + patientKey + `/social-security`, data)
            .pipe(map(pat => {
                return pat;
            }));
    }

    updateAffiliatedPatientMutual(data, patientKey: number) {
        return this.http.put<any>(this.apiUrl + `/affiliated-patient/` + patientKey + `/mutual`, data)
            .pipe(map(pat => {
                return pat;
            }));
    }

    getCodeAuthentForPatient(patientId: number, typeEnvoi: string) {
        return this.http.post(this.apiUrl + `/pat/` + patientId + '/otp/type/' + typeEnvoi, {})
            .pipe(map(pat => {
                return pat;
            }));
    }

    validateCode(patientId: number, codeTemporaire: string) {
        return this.http.post(this.apiUrl + `/pat/` + patientId + '/otp/' + codeTemporaire, {})
            .pipe(map(pat => {
                return pat;
            }));
    }
}
